module.exports = __webpack_public_path__ + "static/media/Google_Pay_Logo.svg.64b7da49.png";